/* eslint-disable @typescript-eslint/no-explicit-any */
// ** React Imports
import { useEffect } from "react";

// ** Store Imports
import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/redux/hooks";
import type { RootState } from "@src/redux/store";
import { handleSkin } from "@src/redux/layout";

export const useSkin = () => {
  // ** Hooks
  const dispatch = useAppDispatch();
  const store = useSelector((state: RootState) => state.layout);

  const setSkin = (type: any) => {
    dispatch(handleSkin(type));
  };

  useEffect(() => {
    // ** Get Body Tag
    const element = window.document.body;

    // ** Define classnames for skins
    const classNames: any = {
      dark: "dark-layout",
      bordered: "bordered-layout",
      "semi-dark": "semi-dark-layout",
    };

    // ** Remove all classes from Body on mount
    element.classList.remove(...element.classList);

    // ** If skin is not light add skin class
    if (store.skin !== "light") {
      element.classList.add(classNames[store.skin]);
    }
  }, [store.skin]);

  return { skin: store.skin, setSkin };
};
